import React, { useEffect, useRef } from 'react';
import  vegaEmbed  from 'vega-embed';

const TamilNaduMap = () => {
    const chartRef = useRef(null);

    useEffect(() => {
        fetch('/tamilnadu.geojson')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                // Process GeoJSON data
            })
            .catch(error => console.error('Error fetching GeoJSON:', error));
    }, []);

    return <div ref={chartRef}></div>;
};

export default TamilNaduMap;
